// cart.model.ts

import { Cart, CartItem } from "../../app/feutures/cart/interface/cart";






export interface  CartState {
  
  cart: Cart | null;
  numOfCartItems: number;
  loading: boolean;
  cartItems: CartItem[];
   discount: number;
}


export const initialCartState: CartState = {
  cart: null,
  numOfCartItems: 0,
  loading: false,
  cartItems: [],
    discount: 0,
};